import { tauiFakeConfig } from "../fake_data/config";

export const fetchConfig = (url: string) => {
  if (__FAKEDATA__) return new Response(JSON.stringify(tauiFakeConfig));
  return fetch(`${url}/config/config.json`, {
    credentials: "same-origin",
  });
};
